export default __webpack_public_path__ + "static/media/portal-screen.bc3541a5.svg";